!function () {
  "use strict";

  const SLIDER_SELECTOR = "[data-slider-mobile]",
        SLIDE_SELECTOR = "[data-slide]",
        THUMB_SELECTOR = "[data-slider-thumb]",
        POPUP_CONTAINER_SELECTOR = "[data-popup-container]",
        POPUP_CLOSE_SELECTOR = "[data-popup-close]",
        CLASS_ANIMATING = "is-animating",
        CLASS_OPEN = "is-open",
        ATTR_THUMB = "data-slider-thumb";

  if (!customElements.get("look-component")) {
    customElements.define(
      "look-component",
      class extends HTMLElement {
        constructor() {
          super();

          this.slider = this.querySelector(SLIDER_SELECTOR);
          this.slides = this.querySelectorAll(SLIDE_SELECTOR);
          this.thumbs = this.querySelectorAll(THUMB_SELECTOR);
          this.popupContainer = this.querySelector(POPUP_CONTAINER_SELECTOR);
          this.popupClose = this.querySelectorAll(POPUP_CLOSE_SELECTOR);

          this.popupCloseByEvent = this.popupCloseByEvent.bind(this);

          // Swiper carousel support (desktop)
          this.swiperCarousel = this.querySelector("s-carousel");
          this.swiperInstance = null;
        }

        connectedCallback() {
          if (this.slider && this.slides.length && this.thumbs.length) {
            // Transition end
            this.popupContainer.addEventListener("transitionend", (event) => {
              if (event.target == this.popupContainer) {
                this.popupContainer.classList.remove(CLASS_ANIMATING);

                if (event.target.classList.contains(CLASS_OPEN)) {
                  this.popupOpenCallback();
                } else {
                  this.popupCloseCallback();
                }
              }
            });

            // Transition start
            this.popupContainer.addEventListener("transitionstart", (event) => {
              if (event.target == this.popupContainer) {
                this.popupContainer.classList.add(CLASS_ANIMATING);
              }
            });

            // Close popup buttons
            this.popupClose.forEach((closeBtn) => {
              closeBtn.addEventListener("click", () => {
                this.popupContainer.classList.remove(CLASS_OPEN);

                document.dispatchEvent(
                  new CustomEvent("theme:scroll:unlock", { bubbles: true })
                );
              });
            });

            // Thumbnail click
            this.thumbs.forEach((thumb, index) => {
              thumb.addEventListener("click", (event) => {
                event.preventDefault();

                const slideIndex =
                  thumb.hasAttribute(ATTR_THUMB) &&
                  thumb.getAttribute(ATTR_THUMB) !== ""
                    ? parseInt(thumb.getAttribute(ATTR_THUMB))
                    : index;

                // --- Desktop with Swiper ---
                if (!window.theme.isMobile() && this.isDesktopWithSwiper()) {
                  this.navigateSwiperToSlide(slideIndex);
                }
                // --- Mobile ---
                else if (window.theme.isMobile()) {
                  const targetSlide = this.slides[slideIndex];
                  const paddingLeft = parseInt(
                    window.getComputedStyle(this.slider).paddingLeft
                  );

                  this.slider.scrollTo({
                    top: 0,
                    left: targetSlide.offsetLeft - paddingLeft,
                    behavior: "auto",
                  });

                  document.dispatchEvent(
                    new CustomEvent("theme:scroll:lock", { bubbles: true })
                  );

                  this.popupContainer.classList.add(
                    CLASS_ANIMATING,
                    CLASS_OPEN
                  );
                }
                // --- Desktop without Swiper ---
                else {
                  const targetSlide = this.slides[slideIndex];
                  const { stickyHeaderHeight } = window.theme.readHeights();

                  const rectTop = targetSlide.getBoundingClientRect().top;
                  const halfHeight = targetSlide.offsetHeight / 2;
                  const viewportHeight = window.innerHeight;

                  let scrollToY =
                    rectTop + halfHeight - viewportHeight / 2 + window.scrollY;

                  const compTop =
                    this.getBoundingClientRect().top + window.scrollY;
                  const compBottom = compTop + this.offsetHeight;

                  if (scrollToY < compTop) {
                    scrollToY = compTop - stickyHeaderHeight;
                  } else if (scrollToY + viewportHeight > compBottom) {
                    scrollToY = compBottom - viewportHeight;
                  }

                  window.scrollTo({
                    top: scrollToY,
                    left: 0,
                    behavior: "smooth",
                  });
                }
              });
            });
          }
        }

        // --- Swiper helpers ---
        isDesktopWithSwiper() {
          if (!this.swiperCarousel) return false;

          const swiperElement = this.swiperCarousel.querySelector(".swiper");
          if (
            !swiperElement ||
            !swiperElement.classList.contains("swiper-initialized")
          ) {
            return false;
          }

          if (!this.swiperInstance) {
            this.swiperInstance = swiperElement.swiper;
          }

          return (
            this.swiperInstance &&
            typeof this.swiperInstance.slideTo === "function"
          );
        }

        navigateSwiperToSlide(index) {
          if (
            this.swiperInstance &&
            typeof this.swiperInstance.slideTo === "function"
          ) {
            this.swiperInstance.slideTo(index, 300); // 300ms transition
          }
        }

        // --- Popup helpers ---
        popupCloseByEvent() {
          this.popupContainer.classList.remove(CLASS_OPEN);
        }

        popupOpenCallback() {
          document.addEventListener(
            "theme:quick-add:open",
            this.popupCloseByEvent,
            { once: true }
          );
          document.addEventListener(
            "theme:product:added",
            this.popupCloseByEvent,
            { once: true }
          );
        }

        popupCloseCallback() {
          document.removeEventListener(
            "theme:quick-add:open",
            this.popupCloseByEvent,
            { once: true }
          );
          document.removeEventListener(
            "theme:product:added",
            this.popupCloseByEvent,
            { once: true }
          );
        }
      }
    );
  }
}();
